import React, { memo } from 'react';

import { IPrintPartProps } from 'store/entity/IPrintTemplatePart';
import {
  PrintSingleTaskConsumer,
  IPrintSingleTaskContext,
} from 'store/context/PrintSingleTaskContext';

import messages from './Messages';
import { SingleTaskPart } from '../styles';

const ProjectNamePart: React.FC<IPrintPartProps<'projectId'>> = ({
  property,
}) => (
  <PrintSingleTaskConsumer>
    {(dataContext: IPrintSingleTaskContext) => {
      const { company, allTasks } = dataContext;
      const project =
        allTasks && company
          ? company.projects?.find((it) => it.id === property)
          : null;
      const projectName = project ? project.name : 'Project not found';

      return (
        <SingleTaskPart>
          <span>{messages.projectNameTitle}: </span>
          <span>{projectName}</span>
        </SingleTaskPart>
      );
    }}
  </PrintSingleTaskConsumer>
);

export default memo(ProjectNamePart);
